import { render, staticRenderFns } from "./rc-tag-display.vue?vue&type=template&id=3e945a84&scoped=true&"
import script from "./rc-tag-display.vue?vue&type=script&lang=js&"
export * from "./rc-tag-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e945a84",
  null
  
)

export default component.exports